import { maybeProp, maybePropOf, prop } from '@ipfabric/utils/fp/prop';
import type { SecuritySchemaMergedState } from 'components/SecuritySchema/model/SecuritySchemaModel';
import type { SecuritySchemaNode } from 'components/SecuritySchema/model/SecuritySchemaNode';
import { securitySchemaNodeFromTest } from 'components/SecuritySchema/model/helpers/securitySchemaNodeFromTest';
import { selectReferencedTestScope } from 'components/SecuritySchema/model/selectors/selectReferencedTestScope';
import { option } from 'fp-ts';
import { flow, pipe } from 'fp-ts/lib/function';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectActiveReferencedTestSchemaRoot: (
  s: SecuritySchemaMergedState,
) => SecuritySchemaNode | null = // returns root node if the tree is available
  createScopedSelector(() =>
    createSelector(
      prop('deviceSecurity'),
      flow(selectReferencedTestScope, maybeProp('name')),
      (deviceSecurity, scopeName) => {
        if (deviceSecurity === null) {
          return null;
        }

        return pipe(
          scopeName,
          option.chain(maybePropOf(deviceSecurity?.objects?.namedTests)),
          option.map(
            securitySchemaNodeFromTest({
              deviceSecurity,
              type: 'referencedTest',
            }),
          ),
          option.toNullable,
        );
      },
    ),
  );
